import { Box, Chip, Typography } from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function Header({ isPrivate }: { isPrivate?: boolean }) {
    const { t } = useTranslation();

    return (
        <Box alignItems="center" mb={2}>
            <Typography
                variant="h5"
                style={{ fontWeight: 800, marginBottom: 5 }}
            >
                {t('gameDetails')}
            </Typography>

            {isPrivate && (
                <Chip
                    label={t('privateGame')}
                    size="small"
                    icon={<Lock />}
                    color="secondary"
                />
            )}
        </Box>
    );
}
